<template>
  <div class="form-item">
    <slot name="label">
      <label v-show="!childLabel" :for="uid" class="block text-sm font-medium leading-5 text-gray-700 cursor-pointer">
        {{ label }} <span v-if="required" class="text-red-500">*</span>
      </label>
    </slot>
    <div class="mt-1 relative">
      <div class="flex">
        <slot name="before_input"/>
        <div class="relative w-full focus-within:z-10 ">
          <slot/>
        </div>
        <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" v-if="isError">
          <svg class="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
               aria-hidden="true">
            <path fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"></path>
          </svg>
        </div>

        <slot name="actions"/>
      </div>
    </div>
    <p class="mt-2 text-sm text-red-600" v-if="isError">
      {{ errorText }}
    </p>
    <slot name="help">
      <p v-if="textHelp && !childLabel" class="mt-2 text-sm" :class="textHelpCls">
        {{ textHelp }}
      </p>
    </slot>
  </div>
</template>

<script>
import id from '@/utils/id'

export default {

  name: "UiFormItem",
  props: {
    childLabel: {
      default: false,
    },
    label: {
      default: ''
    },
    id: {
      default: null,
      type: String
    },
    placeholder: {
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    textHelp: {
      default: ''
    },
    textHelpCls: {
      default: 'text-gray-500'
    },
    errors: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      default: '',
    }

  },
  setup(props){

    const uid = props.id ?? id('id_')
    return {uid}
  },

  data() {
    return {
     // rid: id('id_'),
      local_errors: [],
    }
  },
  computed: {
    isError() {
      //console.log(this.error)
      return this.error.length;
    },
    errorText() {
      return this.error.join(' \n');
    },

    inputClass() {
      return {
        'input-error pr-10': this.isError,
      }
    },
/*    uid() {
      return this.id ? this.id : this.rid;
    },*/
    error() {

      if (this.errors.length > 0)
        return this.errors;
      if (this.local_errors.length > 0)
        return this.local_errors;
      if (this.$parent.errors && this.$parent.errors[this.name])
        return this.$parent.errors[this.name];
      return {};

    }
  },

  mounted() {

  }
}
</script>

<style lang="scss">

</style>